import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { BaseService } from 'src/app/shared/services/base.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';
import { IAttendant, IBaseFilter, IFila, IListByFilterFilas } from '../data/lista.interface';
import { IExcelDownloadResponse } from '../../roles/models/excel';
import { saveAs } from 'file-saver';
import { IDevice } from '../../devices/models/device.interface';

@Injectable({
  providedIn: 'root'
})
export class FilasService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}Queue`

  constructor(private readonly http: HttpClient, protected readonly toast: ToastService) {
    super(toast);
  }

  listarFilas(filter: IListByFilterFilas): Observable<ResponseDefault<IFila[]>> {
    let params = new HttpParams().appendAll({
      pageNumber: filter.pageNumber.toString(),
      pageSize: filter.pageSize.toString(),
      orderBy: filter.orderBy.toString()
    })

    if (filter.companyId) {
      params = params.append('companyId', filter.companyId)
    };

    if (filter.partnerId) {
      params = params.append('partnerId', filter.partnerId)
    }

    if (filter.active) {
      params = params.append('active', filter.active.toString())
    }

    if (filter.searchText) {
      params = params.append('searchText', filter.searchText)
    };

    return this.http.get<ResponseDefault<IFila[]>>(`${this.apiUrl}/ListByFilterAsync`, { params });
  }

  listarFilasPorAtendente(attendantId: string): Observable<ResponseDefault<IFila[]>> {
    return this.http.get<ResponseDefault<IFila[]>>(`${this.apiUrl}/Attendant/${attendantId}`);
  }

  adicionarFila(fila: IFila): Observable<ResponseDefault<string>> {
    return this.http.post<ResponseDefault<string>>(`${this.apiUrl}`, fila);
  }

  detalhesFila(id: string): Observable<ResponseDefault<IFila>> {
    return this.http.get<ResponseDefault<IFila>>(`${this.apiUrl}/${id}`);
  }

  editarFila(dadosFila: IFila, id: string): Observable<ResponseDefault<boolean>> {
    return this.http.put<ResponseDefault<boolean>>(`${this.apiUrl}/${id}`, dadosFila);
  }

  desativarFila(id: string): Observable<ResponseDefault<boolean>> { // mudar aqui para a nova funcionalidade
    return this.http.put<ResponseDefault<boolean>>(`${this.apiUrl}/setInactiveAsync/${id}`, {});
  }

  ativarFila(id: string): Observable<ResponseDefault<boolean>> { // mudar aqui para a nova funcionalidade
    return this.http.put<ResponseDefault<boolean>>(`${this.apiUrl}/setActiveAsync/${id}`, {});
  }

  listDevicesInQueue(queueId: string, filter: IBaseFilter): Observable<ResponseDefault<IDevice[]>> {
    let params = new HttpParams().appendAll({
      pageNumber: filter.pageNumber.toString(),
      pageSize: filter.pageSize.toString(),
      orderBy: filter.orderBy.toString()
    })

    return this.http.get<ResponseDefault<IDevice[]>>(`${this.apiUrl}/${queueId}/Devices`, { params });
  }

  exportarExcelFila(filtros: IListByFilterFilas): void {// mudar aqui para a nova funcionalidade
    this.http.post<IExcelDownloadResponse>(`${this.apiUrl}/ExportExcel`, filtros).subscribe((resposta) => {
      saveAs(`data:${resposta.contentType};base64,${resposta.fileContents}`, resposta.fileDownloadName);
    });
  }

  addDevicesToQueue(queueId: string, devicesId: string[]): Observable<ResponseDefault<boolean>> {
    return this.http.post<ResponseDefault<boolean>>(`${this.apiUrl}/${queueId}/Devices`, { devices: devicesId });
  }

  removeDeviceFromQueue(queueId: string, deviceId: string): Observable<ResponseDefault<boolean>> {
    return this.http.delete<ResponseDefault<boolean>>(`${this.apiUrl}/${queueId}/Device/${deviceId}`);
  }

  listAttendantsInQueue(queueId: string, filter: IBaseFilter): Observable<ResponseDefault<IAttendant[]>> {
    const params = new HttpParams().appendAll({
      pageNumber: filter.pageNumber.toString(),
      pageSize: filter.pageSize.toString(),
      orderBy: filter.orderBy.toString()
    });

    return this.http.get<ResponseDefault<IAttendant[]>>(`${this.apiUrl}/${queueId}/Attendants`, { params });
  }

  addAttendantsToQueue(queueId: string, attendantsId: string[]): Observable<ResponseDefault<boolean>> {
    return this.http.post<ResponseDefault<boolean>>(`${this.apiUrl}/${queueId}/Attendants`, { attendants: attendantsId });
  }

  removeAttendantFromQueue(queueId: string, attendantId: string): Observable<ResponseDefault<boolean>> {
    return this.http.delete<ResponseDefault<boolean>>(`${this.apiUrl}/${queueId}/Attendant/${attendantId}`);
  }
}
